import {h, Fragment} from "preact"
import DynamicProductCard from "./DynamicProductCard"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function Products( {singleViewMobile} ) {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    // console.log("products", products);

    useEffect(() => {
        if(document.querySelector(".snize-close-button")){
            document.querySelector(".snize-close-button").click();
        }
    }, [])

    return (
        <div class="collection-listing filters-adjacent">
            <div 
                class={`product-list product-list--image-shape-square ns-products product-list--per-row-4 ${singleViewMobile ? 'product-list--one-column-mobile' : ''}`}
                style={loading ? "opacity: 0.3;" : ""}
            >
                {products.hits.map((hit, index) => {
                    return <DynamicProductCard product={hit} key={hit.productId || index} />
                })}
            </div>
        </div>
    )
}
